// Suggested zone names per deck — tap to place, or type your own
export const ZONE_PALETTE = {
  'Flybridge': ['Sun deck', 'Hot tub', 'Flybridge helm', 'Stbd bosun locker'],
  'Pilothouse': ['Wheelhouse', 'Chart table', 'GMDSS station'],
  'Main Deck': ['Main salon', 'Master cabin', 'Balcony', 'Main deck aft', 'Swim platform', 'Foredeck', 'Chain locker'],
  'Lower Deck': [
    'Engine room', 'Lazarette', 'Galley', 'Laundry', 'Pantry', 'Crew mess',
    'Crew cabin C1', 'Crew cabin C2', 'Crew cabin C3', 'Crew cabin C4', 'Crew cabin C5',
    'Port VIP', 'Stbd VIP', 'Port twin cabin', 'Stbd twin cabin',
    'Head BA', 'Head BB', 'Head BC', 'Head BD', 'Head BE',
    'Cold storage', 'Fore deck storage', 'Tunnel access',
  ],
  'Outboard Profile': ['Mast'],
}
export function paletteFor(deckName) { return ZONE_PALETTE[deckName] || [] }
